module.exports = __webpack_public_path__ + "img/TT.89de2238.svg";